import styled from"@emotion/styled";import{Modal}from"@wp/src/components/common";import{mediaQuery}from"@wp/src/components/common/grid";export const StyledSecuritiesImportInsistModal=styled(Modal)`
  .ant-modal-header {
    ${mediaQuery({width:["90%","100%"]})}
  }
  .ant-modal-title {
    line-height: normal !important;
  }
`;